import IframeActivity from "./IframeActivity";

export default function EverythingHasAHome() {
    return (
        <IframeActivity
            src="/activities/everything-has-a-home/index.html"
            title="Everything Has a Home"
        />
    );
}